<div>
    <app-searchbar [(value)]="filter"></app-searchbar>
    <div class="m-t-8">
        <span *ngFor="let tag of tags | orderBy: 'title':false | filterBy: ['title']:filter">
            <app-pill-global-tag [tag]="tag"></app-pill-global-tag>
        </span>
    </div>
</div>
